<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">匹配卡配置</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="3">
        <el-select
          style="width: 160px"
          class="header-item"
          v-model="valid"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in valids"
            :key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="cre">
          创建
        </el-button>
      </el-col>
    </el-row>
    <!-- 创建弹窗 -->
    <el-drawer
      title="创建"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>国家：</span>
            <el-select
              filterable
              style="width: 160px"
              v-model="country"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in countryList"
                v-bind:key="itemIndex + 99"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>渠道号：</span>
            <el-select style="width: 160px" v-model="channel" placeholder="">
              <el-option
                v-for="(item, itemIndex) in channelsList"
                v-bind:key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>注册后赠送天数:</span>
            <el-input type="number" v-model="canReceiveTotalDays"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>领取间隔时长（min）:</span>
            <el-input type="number" v-model="receiveWaitingTimeMin"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>每天赠送天数:</span>
            <el-input type="number" v-model="canReceiveTimesPerDay"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>每次赠送张数:</span>
            <el-input type="number" v-model="canReceiveNumsOnce"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>匹配卡规则(不填则给默认值):</span>
            <el-input v-model="matchCardRules"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span>领取匹配卡后的描述（不填则给默认值）:</span>
            <el-input v-model="receivedDesc"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <span>是否有效:</span>
          <el-select
            style="width: 160px"
            class="header-item"
            v-model="valid_"
            placeholder=""
          >
            <el-option
              v-for="(item, itemIndex) in valids_"
              :key="itemIndex"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-row>
        <el-row class="buttom">
          <el-button type="primary" v-if="!msg" @click="establish()"
            >创建</el-button
          >
          <el-button type="primary" v-if="msg" @click="establish(1)"
            >修改</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <!-- 表格 -->
    <el-row class="user-options">
      <el-table
        height="60vh"
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        border
      >
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column prop="countryCode" label="国家" align="center">
        </el-table-column>
        <el-table-column
          prop="canReceiveTotalDays"
          label="注册后赠送天数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="receiveWaitingTimeMin"
          label="领取间隔时长（min）"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="canReceiveTimesPerDay"
          label="每天赠送天数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="canReceiveNumsOnce"
          label="每次赠送张数"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="matchCardRules"
          label="匹配卡规则"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="receivedDesc"
          label="领取匹配卡后的描述"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="valid" label="是否有效" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid == '0' ? '无效' : '有效' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ctime"
          label="创建时间"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            {{ format_(scope.row.ctime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mtime"
          label="修改时间"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            {{ format_(scope.row.mtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="130">
          <template slot-scope="scope">
            <el-button type="primary" @click="modify(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getCountry } from '@/utils/normalApi.js'
export default {
  data () {
    return {
      id: '',
      msg: false,
      receivedDesc: '', //领取匹配卡后的描述（不填则给默认值）
      matchCardRules: '', //匹配卡规则(不填则给默认值)
      canReceiveNumsOnce: 0, //每次赠送张数
      canReceiveTimesPerDay: 0, //每天赠送天数
      canReceiveTotalDays: 0, //注册后赠送天数
      receiveWaitingTimeMin: 0, //领取间隔时长（min）
      channel: 'all',
      channelsList: this.$store.state.channels,
      country: 'all',
      countryList: [],
      drawer: false,
      direction: 'rtl',
      // 加载
      login1: false,
      valid: -1,
      valids: [
        {
          label: '全部',
          value: -1
        },
        {
          label: '有效',
          value: 1
        },
        {
          label: '无效',
          value: 0
        }
      ],
      valid_: 1,
      valids_: [
        {
          label: '有效',
          value: 1
        },
        {
          label: '无效',
          value: 0
        }
      ],
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: []
    }
  },
  created () {
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    format_ (data) {
      let date = new Date(data) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h = date.getHours() + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_match_card_list,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          valid: this.valid,
          page: this.page
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 创建
    async establish (num) {
      let url =
        this.$store.getters.path.config_match_card_create +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        channel: this.channel,
        countryCode: this.country,
        canReceiveTotalDays: this.canReceiveTotalDays,
        receiveWaitingTimeMin: this.receiveWaitingTimeMin,
        canReceiveTimesPerDay: this.canReceiveTimesPerDay,
        canReceiveNumsOnce: this.canReceiveNumsOnce,
        matchCardRules: this.matchCardRules,
        receivedDesc: this.receivedDesc,
        valid: this.valid_
      }
      if (num == 1) {
        url =
          this.$store.getters.path.config_match_card_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          id: this.id,
          channel: this.channel,
          countryCode: this.country,
          canReceiveTotalDays: this.canReceiveTotalDays,
          receiveWaitingTimeMin: this.receiveWaitingTimeMin,
          canReceiveTimesPerDay: this.canReceiveTimesPerDay,
          canReceiveNumsOnce: this.canReceiveNumsOnce,
          matchCardRules: this.matchCardRules,
          receivedDesc: this.receivedDesc,
          valid: this.valid_
        }
      }

      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.handleClose()
      this.getDayChatDetai()
    },
    cre () {
      this.drawer = true
      this.msg = false
    },
    // 修改
    modify (row) {
      this.msg = true
      this.channel = row.channel
      this.country = row.countryCode
      this.receivedDesc = row.receivedDesc
      this.matchCardRules = row.matchCardRules
      this.canReceiveNumsOnce = row.canReceiveNumsOnce
      this.canReceiveTimesPerDay = row.canReceiveTimesPerDay
      this.canReceiveTotalDays = row.canReceiveTotalDays
      this.receiveWaitingTimeMin = row.receiveWaitingTimeMin
      this.valid_ = row.valid
      this.id = row.id
      this.drawer = true
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    },
    handleClose () {
      this.channel = 'all'
      this.country = 'all'
      this.receivedDesc = ''
      this.matchCardRules = ''
      this.canReceiveNumsOnce = 0
      this.canReceiveTimesPerDay = 0
      this.canReceiveTotalDays = 0
      this.receiveWaitingTimeMin = 0
      this.valid_ = 1
      this.drawer = false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
    .line {
      width: 1440px;
      height: 700px;
    }
  }

}
.add {
  .el-row {
    padding: 0 30px;
    span {
      display: block;
      margin: 0 0 10px;
    }
    .el-input {
      width : 150px;
    }
    > .el-cols {
      display: flex;
      align-items: center;
      > span {
        width:80px;
      }
    }
  }
  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px
  }
}
</style>
